// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"Page_ErrorContainer__Xz9hh","ErrorTitle":"Page_ErrorTitle__bEvWX","ErrorMessage":"Page_ErrorMessage__2Llnv"};